<template>
    <b-card no-body>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-card-header>
            <span class="h5">
                ENGENHARIA - CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado ? contrato.vcCodigoEstruturado : '' }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <b-alert variant="secondary" show class="mb-4">
                <h5 class="mb-3"><strong>Financeiro</strong></h5>
                <b-row>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valor contratado (Não inclui aditamentos)">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorContratado
                                    ? formatarMoeda(dadosEngenharia.financeiro.valorContratado)
                                    : 'R$ 0,00'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="% Inicial">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualInicial !== undefined
                                    ? formatarPercentual(dadosEngenharia.financeiro.percentualInicial)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valor aditado">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorAditado
                                    ? formatarMoeda(dadosEngenharia.financeiro.valorAditado)
                                    : 'R$ 0,00'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="% aditado">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualAditado !== undefined
                                    ? formatarPercentual(dadosEngenharia.financeiro.percentualAditado)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valor do saldo contratual">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorSaldoContratual
                                    ? formatarMoeda(dadosEngenharia.financeiro.valorSaldoContratual)
                                    : 'R$ 0,00'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="% saldo contratual">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.percentualSaldoContratual !== undefined
                                    ? formatarPercentual(dadosEngenharia.financeiro.percentualSaldoContratual)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valor total">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorTotal
                                    ? formatarMoeda(dadosEngenharia.financeiro.valorTotal)
                                    : 'R$ 0,00'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valor total de reajuste">
                            <strong>{{
                                dadosEngenharia.financeiro && dadosEngenharia.financeiro.valorTotalReajustamento
                                    ? formatarMoeda(dadosEngenharia.financeiro.valorTotalReajustamento)
                                    : 'R$ 0,00'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                </b-row>
            </b-alert>

            <div class="mb-4">
                <h5 class="mb-3"><strong>Dados contratuais e administrativos</strong></h5>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Procedimento de Licitação</label>
                            <b-form-input
                                v-model="procedimentoLicitacao"
                                placeholder="Digite o procedimento de licitação"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Vigência garantia</label>
                            <date-picker
                                readonly
                                v-model="vigenciaGarantia"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Valor da garantia</label>
                            <money
                                readonly
                                v-model="valorGarantia"
                                v-bind="$moneyConfig"
                                class="form-control text-right"
                            ></money>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Folhas/guia de recebimento</label>
                            <model-list-select
                                :list="folhasGuiaRecebimentoOptions"
                                option-text="text"
                                option-value="value"
                                v-model="folhasGuiaRecebimento"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Reforma</label>
                            <model-list-select
                                :list="reformaOptions"
                                option-text="text"
                                option-value="value"
                                v-model="reforma"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Tipo</label>
                            <model-list-select
                                :list="tipoOptions"
                                option-text="text"
                                option-value="value"
                                v-model="tipo"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Classificação de despesa</label>
                            <model-list-select
                                :list="classificacaoDespesaOptions"
                                option-text="text"
                                option-value="value"
                                v-model="classificacaoDespesa"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Fonte de recurso</label>
                            <multi-select
                                :options="fonteRecursoOptions"
                                :selected-options="fontesRecursoSelecionadas"
                                @select="selecionarFonteRecurso"
                            ></multi-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Ação</label>
                            <b-form-textarea
                                v-model="acao"
                                rows="3"
                                placeholder="Digite a ação"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Sub Ação</label>
                            <b-form-textarea
                                v-model="subAcao"
                                rows="3"
                                placeholder="Digite a sub ação"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <div class="mb-4">
                <h5 class="mb-3"><strong>Engenharia e fiscalização</strong></h5>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>ART Fiscalização</label>
                            <b-form-input
                                type="text"
                                v-model="artFiscalizacao"
                                placeholder="Digite o ART de fiscalização"
                                maxlength="13"
                                v-mask="'XXXXXXXXXXXXX'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Responsável técnico</label>
                            <b-form-input
                                v-model="responsavelTecnico"
                                placeholder="Digite o responsável técnico"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>ART responsável técnico</label>
                            <b-form-input
                                type="text"
                                v-model="artResponsavelTecnico"
                                placeholder="Digite o ART do responsável técnico"
                                maxlength="13"
                                v-mask="'XXXXXXXXXXXXX'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Data licença ambiental</label>
                            <date-picker
                                v-model="dataLicencaAmbiental"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Termo de recebimento</label>
                            <model-list-select
                                :list="termoRecebimentoOptions"
                                option-text="text"
                                option-value="value"
                                v-model="termoRecebimento"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>Data da proposta</label>
                            <date-picker
                                v-model="dataProposta"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label>CNO</label>
                            <b-form-input
                                type="text"
                                v-model="cno"
                                placeholder="Digite o CNO"
                                v-mask="'############'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <b-alert variant="secondary" show>
                <h5 class="mb-3"><strong>Valores de acompanhamento</strong></h5>
                <b-row>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valores acumulados">
                            <strong>{{
                                dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumulados !== undefined
                                    ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumulados)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valores acumulados RJ">
                            <strong>{{
                                dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosRJ !== undefined
                                    ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosRJ)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valores acumulados pagos">
                            <strong>{{
                                dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosPagos !== undefined
                                    ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosPagos)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valores acumulados RJ pago">
                            <strong>{{
                                dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosRJPago !== undefined
                                    ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosRJPago)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6">
                        <app-detalhe titulo="Valores acumulados medido/pago">
                            <strong>{{
                                dadosEngenharia.acompanhamento && dadosEngenharia.acompanhamento.valoresAcumuladosMedidoPago !== undefined
                                    ? formatarMoeda(dadosEngenharia.acompanhamento.valoresAcumuladosMedidoPago)
                                    : '-'
                            }}</strong>
                        </app-detalhe>
                    </b-col>
                </b-row>
            </b-alert>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-arrow-left"></i> Voltar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import ContratosServicos from '../ContratosServicos'
import { ModelListSelect, MultiSelect } from 'vue-search-select'

export default {
    name: 'EngenhariaForm',

    components: {
        ModelListSelect,
        MultiSelect
    },

    data() {
        return {
            erros: [],
            operacao: 'ATUALIZAR',
            contrato: {},
            dadosEngenharia: {},
            procedimentoLicitacao: '',
            vigenciaGarantia: null,
            valorGarantia: null,
            folhasGuiaRecebimento: null,
            reforma: null,
            tipo: null,
            classificacaoDespesa: null,
            fonteRecursoOptions: [
                { value: 'SUAPE', text: 'SUAPE' },
                { value: 'UNIÃO', text: 'UNIÃO' },
                { value: 'FGTS', text: 'FGTS' }
            ],
            fontesRecursoSelecionadas: [],
            acao: '',
            subAcao: '',
            artFiscalizacao: '',
            responsavelTecnico: '',
            artResponsavelTecnico: '',
            dataLicencaAmbiental: null,
            termoRecebimento: null,
            dataProposta: null,
            folhasGuiaRecebimentoOptions: [
                { value: 'Exigido', text: 'Exigido' },
                { value: 'Não exigido', text: 'Não exigido' }
            ],
            reformaOptions: [
                { value: 'Sim', text: 'Sim' },
                { value: 'Não', text: 'Não' }
            ],
            tipoOptions: [
                { value: 'Serviço', text: 'Serviço' },
                { value: 'Obra', text: 'Obra' },
                { value: 'Projeto', text: 'Projeto' }
            ],
            classificacaoDespesaOptions: [
                { value: 'Custeio', text: 'Custeio' },
                { value: 'Investimento', text: 'Investimento' }
            ],
            termoRecebimentoOptions: [
                { value: 'Sim', text: 'Sim' },
                { value: 'Não', text: 'Não' }
            ]
        }
    },

    methods: {
        formatarMoeda(valor) {
            if (!valor && valor !== 0) return 'R$ 0,00'
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(valor)
        },

        formatarPercentual(valor) {
            if (valor === null || valor === undefined) return '-'
            return valor.toFixed(2).replace('.', ',') + '%'
        },

        selecionarFonteRecurso(itens, ultimoSelecionado) {
            this.fontesRecursoSelecionadas = itens
        },

        confirmaSalvar() {
            this.$swal({
                title: "ATUALIZAR",
                html: `Confirma a atualização dos dados de engenharia para o contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor ? this.contrato.fornecedor.nome : ''}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let fonteRecurso = this.fontesRecursoSelecionadas
                .map(item => item.text)
                .join(', ')

            let dadosEngenhariaDto = {
                idContrato: this.contrato.idContrato || this.$route.params.contratoId,
                procedimentoLicitacao: this.procedimentoLicitacao || null,
                folhasGuiaRecebimento: this.folhasGuiaRecebimento || null,
                reforma: this.reforma || null,
                tipo: this.tipo || null,
                classificacaoDespesa: this.classificacaoDespesa || null,
                fonteRecurso: fonteRecurso || null,
                acao: this.acao || null,
                subacao: this.subAcao || null,
                artFiscalizacao: this.artFiscalizacao || null,
                responsavelTecnico: this.responsavelTecnico || null,
                artResponsavelTecnico: this.artResponsavelTecnico || null,
                dataLicencaAmbiental: this.dataLicencaAmbiental != null
                    ? this.$moment(this.dataLicencaAmbiental, 'DD/MM/YYYY').toISOString()
                    : null,
                termoRecebimento: this.termoRecebimento || null,
                dataProposta: this.dataProposta != null
                    ? this.$moment(this.dataProposta, 'DD/MM/YYYY').toISOString()
                    : null,
                cno: this.cno || null
            }

            const dadosContratuaisNulo = !this.dadosEngenharia.dadosContratuais
            const fiscalizacaoNulo = !this.dadosEngenharia.fiscalizacao
            const deveAtualizar = !dadosContratuaisNulo || !fiscalizacaoNulo

            const promessa = deveAtualizar
                ? ContratosServicos.atualizarEngenharia(this.$route.params.contratoId, dadosEngenhariaDto)
                : ContratosServicos.salvarEngenharia(this.$route.params.contratoId, dadosEngenhariaDto)

            promessa.then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Dados de engenharia atualizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$store.dispatch('setRecarregar', true)
                        this.voltar()
                    } else {
                        this.erros = response.errors || []
                        this.$toast.error(
                            'Erro ao atualizar dados de engenharia',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            }).catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Erro ao atualizar dados de engenharia',
                    'ERROR',
                    this.$toastConfig.error
                )
            })
        },

        obterDadosEngenharia() {
            if (window.history.state && window.history.state.contrato) {
                this.contrato = window.history.state.contrato
            } else {
                this.$store.dispatch('addRequest')
                ContratosServicos.obterPorId(this.$route.params.contratoId).then(response => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.contrato = response.data
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }

            if (this.$store.getters.dadosEngenharia) {
                this.dadosEngenharia = this.$store.getters.dadosEngenharia
                this.preencheForm(this.$store.getters.dadosEngenharia)
            } else {
                ContratosServicos.obterEngenharia(this.$route.params.contratoId).then(response => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.dadosEngenharia = response.data || {}
                            this.$store.dispatch('setDadosEngenharia', response.data || {})
                            this.preencheForm(response.data)
                        }
                    }
                }).catch(error => {
                    console.log('Erro ao obter dados de engenharia:', error)
                })
            }
        },

        preencheForm(dados) {
            if (dados) {
                const dadosContratuais = dados.dadosContratuais || {}
                const fiscalizacao = dados.fiscalizacao || {}

                this.procedimentoLicitacao = dadosContratuais.procedimentoLicitacao || ''

                if (dadosContratuais.vigenciaGarantia) {
                    this.vigenciaGarantia = this.$moment(dadosContratuais.vigenciaGarantia).format('DD/MM/YYYY')
                } else {
                    this.vigenciaGarantia = null
                }

                this.valorGarantia = dadosContratuais.valorGarantia || null
                this.folhasGuiaRecebimento = dadosContratuais.folhasGuiaRecebimento || null
                this.reforma = dadosContratuais.reforma || null
                this.tipo = dadosContratuais.tipo || null
                this.classificacaoDespesa = dadosContratuais.classificacaoDespesa || null

                if (dadosContratuais.fonteRecurso) {
                    const fontes = dadosContratuais.fonteRecurso.split(',').map(f => f.trim())
                    this.fontesRecursoSelecionadas = this.fonteRecursoOptions.filter(
                        option => fontes.includes(option.value)
                    )
                } else {
                    this.fontesRecursoSelecionadas = []
                }

                this.acao = dadosContratuais.acao || ''
                this.subAcao = dadosContratuais.subacao || ''

                this.artFiscalizacao = fiscalizacao.artFiscalizacao || ''
                this.responsavelTecnico = fiscalizacao.responsavelTecnico || ''
                this.artResponsavelTecnico = fiscalizacao.artResponsavelTecnico || ''

                if (fiscalizacao.dataLicencaAmbiental) {
                    this.dataLicencaAmbiental = this.$moment(fiscalizacao.dataLicencaAmbiental).format('DD/MM/YYYY')
                } else {
                    this.dataLicencaAmbiental = null
                }

                this.termoRecebimento = fiscalizacao.termoRecebimento || null

                if (fiscalizacao.dataProposta) {
                    this.dataProposta = this.$moment(fiscalizacao.dataProposta).format('DD/MM/YYYY')
                } else {
                    this.dataProposta = null
                }

                this.cno = fiscalizacao.cno || ''
            }
        },

        voltar() {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        }
    },

    created() {
        this.obterDadosEngenharia()
    },

    computed: {
        desabilitarBtnSalvar() {
            return false
        }
    }
}
</script>

